export const TestIds = {
  container: 'first-time-disclaimer',
  title: 'first-time-disclaimer-title',
  titleIcon: 'first-time-disclaimer-title-icon',
  text: 'first-time-disclaimer-text',
  cancelButton: 'first-time-disclaimer-cancel-button',
  acceptButton: 'first-time-disclaimer-accept-button',
};
